@if (content) {
<div
     class="pos-relative w-12 flex-column center-x center-l p-t-10-x p-t-10-l p-b-6-x p-b-6-l bg-col-w size-guide-modal">
    <button class="pos-absolute z-2 top-2 right-0 p-a"
            type="button"
            aria-label="Close"
            (click)="close()">
        <i class="icon-close"
           aria-hidden="true"></i>
    </button>
    <h2 class="h2 p-l-4-s p-l-4-m p-r-4-s p-r-4-m p-t-3-s p-t-3-m p-b-3-s bg-col-51-s bg-col-51-m size-guide-header"
        *iCms="'title' of content"></h2>
    <div class="w-12 p-t-5 p-t-7-m p-t-7-s p-b-5 p-b-7-m p-b-7-s flex-grow overflow-y-auto custom-scrollbar">
        @if (content.subtitle) {
        <h4 class="h4 m-b-6 p-l-4-s p-l-4-m p-r-4-s p-r-4-m"
            *iCms="'subtitle' of content"></h4>
        }
        @if (content.tables.length > 0 && tableOptions) {
        @for (table of content.tables; track $index; let i = $index) {
        <div class="m-b-6 p-l-4-s p-l-4-m p-r-4-s p-r-4-m">
            @if (table.toggleVisibility) {
            <div class="m-b-6">
                @if (table.toggleTitle) {
                <span class="h4 m-r-4 block-s block-m m-b-5-s m-b-5-m"
                      *iCms="'toggleTitle' of table"></span>
                }
                @if (table.toggleOptionFirst) {
                <span class="h4 p-r-3"
                      [ngClass]="tableOptions[i] ? 'col-12' : 'col-11'"
                      *iCms="'toggleOptionFirst' of table"></span>
                }
                <toggle class="inline-block"
                        [(ngModel)]="tableOptions[i]"
                        (ngModelChange)="detectChanges()"></toggle>
                @if (table.toggleOptionSecond) {
                <span class="h4"
                      [ngClass]="tableOptions[i] ? 'col-11' : 'col-12'"
                      *iCms="'toggleOptionSecond' of table"></span>
                }
            </div>
            }
            <div class="inline-block">
                <table class="inline-block">
                    @for (row of table.rows; track $index; let x = $index) {
                    <tr>
                        @for (column of row.columns; track $index; let isEven = $even; let y = $index) {
                        <td class="b-col-4 center va-m p-l-1 p-r-1 table-cell"
                            [ngClass]="{'bg-col-51' : isEven && column.valueFirst, 'b-a' : column.valueFirst, 'table-cell-header' : y === 0}">
                            @if (tableOptions[i] ? column.valueSecond : column.valueFirst) {
                            <span [ngClass]="x === 0 || y === 0 ? 'p1' : 'p2'"
                                  [innerHTML]="tableOptions[i] ? column.valueSecond : column.valueFirst">
                            </span>
                            }
                        </td>
                        }
                    </tr>
                    }
                </table>
                @if (table.tableCopy) {
                <div class="flex">
                    <p class="col-12 p2 m-t-2 left flex-grow table-copy"
                       *iCms="'tableCopy' of table">
                    </p>
                </div>
                }
            </div>
        </div>
        }
        }
        @if (content.copy) {
        <div class="w-12 center">
            <p class="p2 w-7 w-12-s w-12-m p-l-6 p-r-6 p-l-4-s p-l-4-m p-r-4-s p-r-4-m m-b-8 left"
               *iCms="'copy' of content"></p>
        </div>
        }
        @if (content.imageTitle) {
        <h4 class="h4 m-b-6 p-l-4-s p-l-4-m p-r-4-s p-r-4-m"
            *iCms="'imageTitle' of content"></h4>
        }
        @if (content.image) {
        <div class="w-12 center">
            <div class="w-10 w-12-s w-12-m m-b-5 p-l-4-s p-l-4-m p-r-4-s p-r-4-m">
                <div class="w-12 ratio-16-9 ratio-2-3-s ratio-2-3-m">
                    <img [image]="content.image"
                         class="rf">
                </div>
            </div>
        </div>
        }
        @if (content.imageCaption) {
        <div class="w-12 center">
            <div class="p2 w-6 w-12-s w-12-m p-l-5 p-l-4-s p-l-4-m p-r-4-s p-r-4-m left"
                 [innerHTML]="content.imageCaption"></div>
        </div>
        }
    </div>
</div>
}